// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "../../../themes/theme-capri-prod/assets/css/" + ({"7":"restaurant","177":"home","231":"checkout","637":"order"}[chunkId] || chunkId) + "." + {"7":"db2c76ac","177":"ca50fe3e","231":"f9ffbbcf","637":"259cc371","686":"e6ebb9d9"}[chunkId] + ".css";
};